import React, { useMemo } from 'react';
import { bool, func, string } from 'prop-types';
import { XData } from '@core/utils';

// devExtreme
import { DropDownButton } from 'devextreme-react';
import Button from 'devextreme-react/button';

export const ToolbarDropDownButton = ({
  additionalActionButtonData,
  disabled = false,
  labelTitle = null
}) => {
  const buttonId = useMemo(() => XData.generateId(), []);
  const inpId = useMemo(() => XData.generateId(), []);

  const dropDownButtonHandler = (e) => {
    const { itemData } = e;
    const actionFind = additionalActionButtonData.find(
      (el) => itemData.id === el.id
    );
    actionFind.customFunction();
  };

  const renderSplitButton = () => (
    <label title={labelTitle} htmlFor={buttonId}>
      <DropDownButton
        splitButton
        icon="runner"
        text=""
        visible={additionalActionButtonData === undefined ? false : true}
        items={undefined ? null : additionalActionButtonData}
        onItemClick={dropDownButtonHandler}
        displayExpr="name"
        keyExpr="id"
        onButtonClick={
          undefined
            ? null
            : () => additionalActionButtonData[0].customFunction()
        }
        dropDownOptions={{
          width: '250px'
        }}
      />
    </label>
  );

  const renderSingleActionButton = () => (
    <label
      className="datagrid-toolbar-btn-labeled"
      title={additionalActionButtonData[0].name}
      htmlFor={inpId}
    >
      <Button
        type="normal"
        stylingMode="contained"
        icon="runner"
        onClick={() => additionalActionButtonData[0].customFunction()}
        visible={additionalActionButtonData.length === 0 ? false : true}
      />
      <input id={inpId} webkitdirectory="true" directory="true" />
    </label>
  );

  return additionalActionButtonData.length > 1
    ? renderSplitButton()
    : renderSingleActionButton();
};

ToolbarDropDownButton.propTypes = {
  disabled: bool,
  labelTitle: string
};
